import React from "react";
import {Box, Heading, Form, FormField, TextInput, Button, CheckBox, FileInput, Select, DateInput} from "grommet";
import {QUERY_PACKAGE_LIST, QUERY_USER_PACKAGE_LIST, UPSERT_USER} from "./UserGQL.js";
import { useLazyQuery,useMutation } from '@apollo/client';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import {extractIdFormData} from "../../../utilis/utils";
import moment from "moment";
import {QUERY_SERVICE_AREA_LIST} from "../clubmateService/ServiceGQL.js";
export default function AddUser(props) {

  const [formData,setFormData]=React.useState();
  const [mutationUpsertDip]=useMutation(UPSERT_USER);
  const [selectedAree,setSelectedAree] = React.useState([]);
  const [selectedPackage,setSelectedPackage] = React.useState([])
  const [packageList,setPackageList] = React.useState([])
  const [areeList,setAreeList] = React.useState([]);

  const onChangeTextInput=(event)=>{
    if(event.target.type==="number"){
      setFormData({...formData,[event.target.name]:parseFloat(event.target.value)})
    }else if(event.target.type==="date"){
      setFormData({...formData,[event.target.name]:moment(event.target.value).format("YYYY-MM-DD")})
    }else{
      setFormData({...formData,[event.target.name]:event.target.value})
    }
  }

  const [ queryPackageList
  ]  = useLazyQuery(QUERY_PACKAGE_LIST, {
  fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data["clubmate_clubmatepackage_clubmatepackage"]){
        setPackageList(data["clubmate_clubmatepackage_clubmatepackage"]);
      }
    },
    onError:(error)=>{
      console.log(error);
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

  const [ queryPackageUser
  ]  = useLazyQuery(QUERY_USER_PACKAGE_LIST, {
  fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data["clubmate_clubmatepackage_clubmatepackage"]){
        setSelectedPackage(data["clubmate_clubmatepackage_clubmatepackage"]);
      }
    },
    onError:(error)=>{
      console.log(error);
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

  
  function onUpsertDip(){
    let obj= extractIdFormData(formData,true,true);
    delete obj?.variables?.input["_Typename"]
    delete obj?.variables?.input["walletId"]
    //obj.variables.input["packages"]=JSON.stringify(selectedPackage.map((pacchetto)=>pacchetto?.id))
    mutationUpsertDip(obj)
    .then((value)=>{
      //setFormData(value.data[`${tenant}`][`upsertUser${tenantTypeFirstUpperCase}`])
      alert("Utente aggiunto correttamente");
      onEscLayer();
    }).catch((value)=>{
      console.error(value);
      alert("Errore durante l'operazione");
    })
  }

  React.useEffect(() =>{
    queryPackageList()
    if(props?.elementSel){
      queryPackageUser({variables:{userId:props?.elementSel?.id}})
       setFormData(props?.elementSel)
    }
  },[])

  function onEscLayer(){
    if(props.onEscLayer){
        props.onEscLayer();
    }
    setFormData({});
  }

  function handleChange(option){
    setSelectedPackage(option);
  }
  
  return (
    <Box height="100%" round pad="medium" direction="column" background="#ffffff" align="center" overflow="auto">
      <Heading level="2" margin="none" size="small" style={{fontWeight:'bold',textTransform: 'uppercase'}}>
        <Box direction="row" gap="large">
          {!props.elementSel?"Inserisci personale":"Aggiorna personale"}
          {/*<Button label="Scarica modello" href={"./modelliCsv/Modello_Personale.csv"} style={{width:'200px',fontSize:'20px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase',textAlign:"center"}}></Button>  */}
        </Box>
      </Heading>
      <Box align="center" gap="small">
        <Form style={{marginTop:"50px"}}>
        <Box direction="row" align="center" >
          <Box pad="xsmall">
            <FormField required label="Nome">
              <TextInput
                style={{fontWeight:"bold"}}
                name="name"
                value={formData?.name}
                onChange={e => onChangeTextInput(e)}
              />
            </FormField>
          </Box>
          <Box pad="xsmall">
            <FormField required label="Cognome">
              <TextInput
                style={{fontWeight:"bold"}}
                name="surname"
                value={formData?.surname}
                onChange={e => onChangeTextInput(e)}
              />
            </FormField>
          </Box>
          <Box pad="xsmall">
            <FormField required label="Codice fiscale" >
              <TextInput
                style={{fontWeight:"bold"}}
                name="fiscal_code"
                value={formData?.fiscal_code}
                onChange={e => onChangeTextInput(e)}
              />
            </FormField>
          </Box>
        </Box> 
        <Box gap="small"direction="horizontal" align="center" style={{marginTop:30+"px"}}>
          <FormField required label="Data di nascita">
            <TextInput
              type="date"
              format="mm/dd/yyyy"
              value={formData?.date_of_birth}
              name="date_of_birth"
              onChange={e => onChangeTextInput(e)}
            />
          </FormField>
          <FormField required label="Numero di telefono">
            <TextInput
              name="telephone_number"
              value={formData?.telephone_number}
              onChange={e => onChangeTextInput(e)}
            />
          </FormField>
          <FormField required label="Numero tessera">
            <TextInput
                name="golf_card_number"
                value={formData?.golf_card_number}
                onChange={e => onChangeTextInput(e)}
            />
          </FormField>
        </Box>
        <Box gap="small"direction="horizontal" align="center" style={{marginTop:30+"px"}}>
          <FormField required label="Codice ERP">
            <TextInput
                name="external_erp_code"
                value={formData?.external_erp_code}
                onChange={e => onChangeTextInput(e)}
            />
          </FormField>
        </Box>
        <Box direction="horizontal" align="center" style={{marginTop:30+"px"}} gap={"small"}>

          <FormField required label="Pachetti">
            <Autocomplete
              multiple
              disablePortal
              disablePortal={true}
              id="packages"
              value={selectedPackage}
              getOptionKey={(option) => option?.id}
              getOptionLabel={(option) => option?.name}
              options={packageList}
              sx={{ width: 300 }}
              renderInput={(params) => <TextField {...params} label="Pachetti" />}
              //onChange={(event, value) => handleChange(value)}
            />
          </FormField>
          <CheckBox
              checked={formData?.partner}
              label="Socio?"
              onChange={(event) => setFormData({...formData,partner:event.target.checked})}
          />
        </Box>
      </Form>
      <Box direction="row" gap="medium" alignSelf="center" style={{marginTop:30+"px"}}>
          <Button label={!props.elementSel?"Aggiungi":"Aggiorna"} onClick={onUpsertDip} style={{width:'170px',height:'34px',fontSize:'18px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase'}}/>
      </Box>
      </Box>
     
    </Box>
  )
}

/*
 <Select
                  options={packageList}
                  value={selectedPackage}
                  multiple={true}
                  labelKey={"name"}
                  valueKey={"name"}
                  closeOnChange={false}
                  onChange={( option ) => handleChange(option)}
                />
                */

